import React from 'react'
import { useSelector } from 'react-redux'

import Text from 'components/common/Text'
import { trackKinds } from 'constants/twilio'
import useDominantSpeaker from 'hooks/useDominantSpeaker/useDominantSpeaker'
import { getIdentity } from 'hooks/useParticipants/useParticipants'
import usePublications from 'hooks/usePublications/usePublications'
import useTrack from 'hooks/useTrack/useTrack'
import { getIsLocal } from 'store/selectors/User'

const ActiveSpeaker = () => {
    const dominantSpeaker = useDominantSpeaker()
    const identity = getIdentity(dominantSpeaker?.identity)
    const isLocal = useSelector(state => getIsLocal(state, identity?.uuid))

    const publications = usePublications(dominantSpeaker)
    const audioPublication = publications.find(p => p.kind === trackKinds.audio)
    const audioTrack = useTrack(audioPublication)
    const isEnabled = audioTrack?.isEnabled

    if (!dominantSpeaker || !isEnabled) return null

    return (
        <Text level="3" color="#10D08B">
            {isLocal ? 'You' : identity?.firstName} {isLocal ? 'are' : 'is'}{' '}
            speaking
        </Text>
    )
}

export default ActiveSpeaker
